/**
 * Versionsstand des Tools.
 *
 * VERSION pflegt der Entwickler von Hand (MAJOR.MINOR.PATCH):
 *   MINOR  neue Funktion oder neues Modul
 *   PATCH  Fehlerkorrektur
 *
 * AENDERUNGEN ist die Seite "Neu in dieser Version": neueste zuerst, kurz und
 * in der Sprache der Anwender, nicht der Entwickler. Das Datum der obersten
 * Zeile ist der angezeigte Stand.
 */

export const VERSION = '1.11.1';

export interface Aenderung {
  nummer: string;
  datum: string; // JJJJ-MM-TT
  punkte: string[];
}

export const AENDERUNGEN: Aenderung[] = [
  {
    nummer: '1.11.1',
    datum: '2026-11-04',
    punkte: [
      'Buchen-Seite: Bei einer Korrektur ließ sich versehentlich der interne Gegenbuchungsplatz „DIFFERENZ" als Lagerplatz wählen – dann meldete die Buchung „Quelle und Ziel sind identisch". Die internen Plätze (DIFFERENZ, EXTERN-WE/WA) werden in der Platzauswahl nicht mehr angeboten; der Server bucht sie weiterhin automatisch als Gegenseite.',
      'Lager-App: Schutz gegen Doppelbuchungen – jede Buchung trägt jetzt einen Schlüssel, sodass ein erneutes Antippen oder ein Wiederholen nach abgebrochener Verbindung nicht ein zweites Mal bucht (erfordert die aktuelle App-Version).',
    ],
  },
  {
    nummer: '1.11.0',
    datum: '2026-11-04',
    punkte: [
      'Neues konfigurierbares Recht „Artikel anlegen & bearbeiten": Unter „Rollen & Rechte" (GF/Admin-Cockpit) lässt sich je Rolle festlegen, wer Artikel anlegen und bearbeiten darf – ein neuer Abschnitt „Zusatzrechte". Voreinstellung: alle operativen Rollen (auch Lager und Schichtleitung) dürfen es, damit neue Ware direkt in der App erfasst werden kann; die Geschäftsführung kann es einzelnen Rollen entziehen. Löschen von Artikeln bleibt den kaufmännischen Rollen vorbehalten.',
    ],
  },
  {
    nummer: '1.10.0',
    datum: '2026-11-03',
    punkte: [
      'Neues GF/Admin-Cockpit unter „Verwaltung": ein Einstieg für Benutzer, Rollen & Rechte, Fonds, Module & Betriebsart, Offline-Bridge, System & Datensicherung und Protokoll. Das Menü ist dadurch schlanker – statt sieben Einzelpunkten gibt es einen Eintrag, von dem aus alles erreichbar ist. Angezeigt werden nur die Kacheln, für die man berechtigt ist.',
    ],
  },
  {
    nummer: '1.9.1',
    datum: '2026-11-03',
    punkte: [
      'Menü aufgeräumt: „Fonds (Abteilungen)" liegt jetzt unter Verwaltung statt unter Stammdaten – es ist Auftraggeber-Konfiguration, kein allgemeines Stammdatum. Der nicht fertige Punkt „Sendungen & Labels" ist ausgeblendet.',
    ],
  },
  {
    nummer: '1.9.0',
    datum: '2026-11-02',
    punkte: [
      'Containernummer wird beim Vereinnahmen vorerst nicht mehr auf das ISO-6346-Format geprüft – freie Eingabe in App und Weboberfläche. Eine gültige Nummer wird weiterhin sauber normalisiert übernommen.',
    ],
  },
  {
    nummer: '1.8.0',
    datum: '2026-11-02',
    punkte: [
      'Bestellportal: strukturierte Lieferanschrift statt einem Freitextfeld – Firma, Vor-/Nachname, Straße, PLZ, Ort und ein Feld für zusätzliche Infos. Das Notizfeld ist jetzt ein großes mehrzeiliges Feld.',
      'Die erfasste Lieferanschrift hat auf dem DHL-Label und dem Lieferschein Vorrang und wird am Packtisch angezeigt.',
    ],
  },
  {
    nummer: '1.7.0',
    datum: '2026-10-29',
    punkte: [
      'Packtisch zeigt jetzt alle eingegangenen Aufträge (auch noch nicht kommissionierte). Ein nicht kommissionierter Auftrag lässt sich dort mit einem Klick „Kommissionieren" versandfertig machen und direkt mit DHL-Label verladen.',
      'Lagergeld-Rechnung mit Fond-Aufstellung: Rechnung und Vorschau zeigen zusätzlich die im Zeitraum versandten Anforderungen gruppiert nach Fond (Abteilung) - als Grundlage zur Weiterverrechnung.',
    ],
  },
  {
    nummer: '1.6.0',
    datum: '2026-10-28',
    punkte: [
      'Anmeldung wahlweise mit Benutzername oder E-Mail: In der Benutzerverwaltung lässt sich je Benutzer ein optionaler Benutzername vergeben; angemeldet wird dann mit Benutzername oder E-Mail.',
    ],
  },
  {
    nummer: '1.5.0',
    datum: '2026-10-28',
    punkte: [
      'Fonds (Abteilungen zur Abrechnung): Unter „Stammdaten → Fonds" lassen sich je Auftraggeber Abteilungen/Kostenträger anlegen. Im Bestellportal gibt der Auftraggeber beim Anfordern seinen Fond an – gibt es Fonds, ist die Angabe Pflicht.',
      'Der gewählte Fond hängt am Auftrag und steht am Packtisch, in der Auftragsansicht und in der Anforderungsübersicht des Kunden.',
    ],
  },
  {
    nummer: '1.4.0',
    datum: '2026-10-16',
    punkte: [
      'Datensicherung an einen zweiten Ort: Zusätzlich zur nächtlichen Sicherung kann eine verschlüsselte Kopie automatisch an ein externes Ziel gehen (FTP, WebDAV, SFTP oder Objektspeicher). Unter „System → Datensicherung" zeigt eine neue Kachel, wann zuletzt ausgelagert wurde – bleibt es aus, wird gewarnt.',
    ],
  },
  {
    nummer: '1.3.0',
    datum: '2026-10-16',
    punkte: [
      'Aufgeräumtes Menü: „Scannen" ist in die globale Suche oben gewandert, „Chargen" und „Seriennummern" sind als „Rückverfolgung" mit zwei Reitern zusammengefasst, und „Standtage & Lagergeld" steht jetzt unter Abrechnung.',
      'Rechtevergabe bis auf den einzelnen Menüpunkt: In „Rollen & Rechte" lässt sich für jede Rolle jeder Menüpunkt gezielt ab- und anwählen – abgewählte Punkte sind für die Rolle nicht mehr sichtbar.',
    ],
  },
  {
    nummer: '1.2.0',
    datum: '2026-10-16',
    punkte: [
      'Globale Suche in der Kopfzeile: oben auf jeder Seite nach Artikeln, Containern, Lagerplätzen, Partnern und Aufträgen suchen – ein Klick auf den Treffer springt direkt hin.',
      'Direkt scannen: Ein Handscanner tippt seinen Code in dieses Feld, mit Enter springt die WaWi sofort zum passenden Artikel oder Container.',
    ],
  },
  {
    nummer: '1.1.0',
    datum: '2026-10-12',
    punkte: [
      'Container-Lagergeld: Standtage und Kosten je Container auf einer eigenen Übersicht – Vereinnahmung, Auslagerung und Standgeld getrennt, mit Summen.',
      'Abrechnung abschließen: den offenen Betrag bis zu einem Stichtag festschreiben (z. B. monatlich). Danach zählt die WaWi ab dem Stichtag weiter und rechnet nichts doppelt.',
      'Abrechnungsläufe nachlesen und bei Bedarf wieder löschen – dann werden die Beträge erneut offen.',
      'Container-Etikett: Unter dem QR-Code steht jetzt gut sichtbar die Container-Nummer.',
      'Fotos zu Containern und Wareneingang werden in der Weboberfläche wieder angezeigt.',
      'Neue Anmeldeseite mit Markenfläche; oben steht der Mandant, passend zur jeweiligen Adresse.',
      'App: Lagerplätze selbst anlegen, bearbeiten, per QR-Code erfassen und löschen.',
      'Kartonweise einlagern: am Artikel die Stückzahl je Karton pflegen – beim Einlagern Kartons erfassen, gebucht wird die tatsächliche Stückzahl.',
      'Artikelnummern können automatisch fortlaufend vergeben werden, wenn kein eigenes Kürzel eingetragen ist.',
      'DHL-Versandlabel direkt aus dem Packtisch (Parcel DE).',
      'Artikel-Etiketten mit QR-Code und Barcode, in der Weboberfläche und in der App.',
    ],
  },
  {
    nummer: '1.0.0',
    datum: '2026-10-12',
    punkte: [
      'Erste versionierte Fassung – ab hier steht unten die Version und diese Seite zeigt, was neu ist.',
      'Lager: Bestände, Lagerplätze, Wareneingang mit Fotos, Umlagern und Buchen, Inventur.',
      'Auftragsabwicklung: Kommissionierung, Packtisch, Versand und Retouren.',
      'Auftraggeber-Bestellportal: Kunden stellen Anforderungen, die direkt im Packtisch landen.',
      'Container-Verwaltung über gedruckte QR-Codes, mit Fotos und Bewegungsverlauf.',
      'Stammdaten für Artikel, Partner und Lagerstruktur; Etikettendruck.',
      'Auswertungen, Lagerwert und Lagergeld-Abrechnung.',
      'GoBD/Betriebsprüfung, Rollen und Rechte, mobile App fürs Lager.',
    ],
  },
];

/** "Version 1.1.0 · 12.10.2026" aus der obersten Änderungszeile. */
export function versionText(): string {
  const stand = AENDERUNGEN[0]?.datum;
  if (stand) {
    const [jahr, monat, tag] = stand.split('-');
    return `Version ${VERSION} · ${tag}.${monat}.${jahr}`;
  }
  return `Version ${VERSION}`;
}
